import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { CardTag, CardImageContainer, CardInfo, CardHeading, CardDescription } from './styles';

const PromotionCard = ({ img, heading, description, link, type }) => (
  type === 'promo' ? (
    <button type="button" style={{ height: '100%', width: '100%', display: 'inline-block', textAlign: 'left', cursor: 'pointer' }} data-sumome-listbuilder-id="701577b4-dc0b-4c95-b2ce-5aeea66cdd30">
      <CardTag>
        <CardImageContainer>
          <img src={`${img}?forcepreloadonly`} alt={heading} />
        </CardImageContainer>
        <CardInfo>
          <CardHeading>{heading}</CardHeading>
          <CardDescription>{description}</CardDescription>
        </CardInfo>
      </CardTag>
    </button>
  ) : (
    <Link href={link}>
      <a style={{ height: '100%', width: '100%', display: 'inline-block' }}>
        <CardTag>
          <CardImageContainer>
            <img src={`${img}?forcepreloadonly`} alt={heading} />
          </CardImageContainer>
          <CardInfo>
            <CardHeading>{heading}</CardHeading>
            <CardDescription>{description}</CardDescription>
          </CardInfo>
        </CardTag>
      </a>
    </Link>
  )
);

PromotionCard.propTypes = {
  img: PropTypes.string.isRequired,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  link: PropTypes.string,
  type: PropTypes.string,
};

export default PromotionCard;
